import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import Signin from "./screens/Signin";
import Navbar from "./components/navbar";
import Dashboard from "./components/admin/dashbord";
import SplashScreen from "./screens/SplashScreen";
import { Provider } from "react-redux";
import store from "../src/store/store";
import CustomToast from "./widgets/toaster";
import { ToastContainer } from "react-toastify";
import { setToastFunction, triggerToast } from "./widgets/toaster/toastManager";
import { ToastNotifier } from "./widgets/toaster/ToastNotifier";

function App() {
  const [toastMessage2, setToastMessage2] = useState("");
  const [toastType, setToastType] = useState<any>("");
  

  setToastFunction((msg: string, type) => {
    setToastMessage2(msg);
    setToastType(type);
  });

  useEffect(() => {
    // Provide a function that shows the toast and resets the state after a delay
    setToastFunction((msg: string, type) => {
      setToastMessage2("");
      setToastType(type);
      setTimeout(() => setToastMessage2(msg), 10);
      setTimeout(() => setToastType(type), 10);
    });
  }, []);

  useEffect(() => {
    const handleClick = () => {
      if (!navigator.onLine) {
        triggerToast(
          "Unable to reach the server. Please check your network connection and try again.", "error"
        );
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <Provider store={store}>
      <SplashScreen />
      {toastMessage2 && <ToastNotifier message={toastMessage2} type={toastType} onClose={() => setToastMessage2("")} />}
    </Provider>
  );
}

export default App;
